// import eventsImage from '../assets/imgs/IMG_1397.JPG';
import musicianImage from '../assets/imgs/IMG_2261.JPG';
import reviewImage from '../assets/imgs/Nat_img.jpg'
import logo_white from "../assets/logos/Relic-logo_white.png";
import logo_gold from '../assets/logos/Relic-logo_gold.png';
import logo_black from '../assets/logos/Relic-logo_black.png';
import logo_blue from '../assets/logos/Relic-logo_blue.png';
import reviewBg from '../assets/imgs/review_bg.jpg';
import reviewBgV from '../assets/imgs/Nat_img.jpg';
import videoBg from '../assets/imgs/bg_video.jpg';
import aboutBgH from '../assets/imgs/about_bg_h.jpg';
import aboutbgV from '../assets/imgs/about_bg_v.jpg';
import generalBg from '../assets/imgs/general_bg.jpg';
import goldBg from '../assets/imgs/gold_bg.jpg';
import pantheonBg from '../assets/imgs/pantheon_bg.jpg';


const images = {
    // eventsImage,
    musicianImage,
    reviewImage
};

export const bgs = {
    reviewBg,
    videoBg,
    aboutBgH,
    aboutbgV,
    generalBg,
    reviewBgV,
    goldBg,
    pantheonBg
};

export default images;

export const logos = {
    logo_black,
    logo_blue,
    logo_gold,
    logo_white
}